export const backendEndpoints = {
    confirmPassword: '/user/confirm-password-custom',
    twoFactorQrCode: '/user/two-factor-qr-code',
    twoFactorAuthentication: '/user/two-factor-authentication',
    getLoggedUiEvents: '/admin/logged-ui-events',
    inviteUserToGroup: (groupId: number | string) => `/groups/${groupId}/invite-user`,
    inviteUserToCourseGroup: (groupId: number | string) => `/eln/course-groups/${groupId}/invite-user`,
    joinCourse: (courseId: number | string) => `/eln/courses/${courseId}/join`,
    updateUser: (userId: number) => "/users/"+userId+'?_with[]=files&_with[]=custom_fields',
    userId: (userId: number) => `/users/${userId}`,
    userAccountWasCompleted: (userId: string | number) => `/users/${userId}/is-completed`,
    updateGroup: (groupId: number) => `/groups/${groupId}`,
    deleteGroup: (groupId: number) => `/groups/${groupId}`,
    callMeBack: `/community/call-me-back`,
    leaveGroup: (groupId: number) => "/groups/"+groupId+"/leave",
    getGroup: (groupId: number) => `/groups/${groupId}`,
    getGroupViaHash: (groupId: number | string, hash: string) => `/groups/${groupId}/hash/${hash}`,
    getCourseViaHash: (courseId: number | string, hash: string) => `/eln/courses/${courseId}/hash/${hash}`,
    getShareRequestViaHash: (shareRequestIds: string, hash: string) => `/share-requests/${shareRequestIds}/hash/${hash}`,
    copyShareRequest: (shareRequestIds: string, hash: string) => `/share-requests/${shareRequestIds}/copy-to-recipient/${hash}`,
    forgotPassword: '/forgot-password',
    seedContent: (userId: number | string) => `/users/${userId}/seed-content`,
    resetPassword: '/reset-password',
    createGroup: '/groups',
    getGroups: '/groups',
    getUserGroups: (userId: number) => `/users/${userId}/groups`,
    getGroupsWithSubscriptions: '/groups?_with[]=subscriptions',
    getAdminCommunicationMocks: '/admin/communication-mocks',
    getAdminGroups: '/admin/groups?_with[]=users',
    getAdminProducts: '/admin/products',
    getAdminPrices: '/admin/prices',
    getAdminUsers: `/admin/users`,
    deleteAdminUser: (userId: number | string) => `/admin/users/${userId}`,
    getAdminUserStats: '/admin/users/stats',
    adminUserFilesCount: (userId: string | number) => `/admin/users/${userId}/files-count`,
    // Get the notes with the user who created it, its revisions and sort them by date.
    getAdminNotes: '/admin/notes?_with[]=createdBy&_with[]=child_notes&_orderBy=created_at&_orderDirection=asc&parent_note_id=null',
    postAdminNotes: '/admin/notes',
    postBatchNotifications: '/admin/notifications/send-many',
    getAdminNotificationsForDisplay: '/admin/notifications/for-display',
    getAdminLoggedMail: '/admin/logged-mails',
    getAdminSubscriptions: '/admin/subscriptions',
    changeSeats: (subscriptionId: number) => `/stripe/subscriptions/${subscriptionId}/change-seats`,
    takeSeat: (groupId: number) => `/groups/${groupId}/take-seat`,
    grantSeat: (groupId: number) => `/groups/${groupId}/grant-seat`,
    // Restoring can only happen via the admin environment
    restoreUser: (userId: number | string) => `/admin/users/${userId}/restore`,
    // Restoring can only happen via the admin environment
    restoreGroup: (groupId: number | string) => `/admin/groups/${groupId}/restore`,
    adminSubscription: (subscriptionId: number  | string) => `/admin/subscriptions/${subscriptionId}`,
    addSubscriptionRule: `/admin/subscription-rules`,
    adminSubscriptionRule: (ruleId: number | string) => `/admin/subscription-rules/${ruleId}`,
    adminSubscriptionRuleTypes: `/admin/subscription-rules/types`,
    adminSubscriptionRuleProducts: `/admin/subscription-rules/products`,
    adminSubscriptionRuleTimeTypes: `/admin/subscription-rules/time-types`,
    adminSendCompleteAccountEmail: (userId: number | string) => `/admin/users/${userId}/send-complete-account-mail`,
    getSubscriptionRules: `/admin/subscription-rules?_with[]=institute`,
    deleteSubscriptionRule: (ruleId: number | string) =>  `/admin/subscription-rules/${ruleId}`,
    subscriptionRule: (ruleId: number | string) => `/admin/subscription-rules/${ruleId}`,
    login: '/create-token',
    signUp: '/register',
    tokens: '/tokens',
    getFiles: '/files',
    billingPortal: '/billing-portal',
    switchSubscription: (userId: number) => `/users/${userId}/subscriptions/switch`,
    getAdminInstitutes: '/admin/institutes',
    getAdminFiles: '/admin/files?include_files_exists=1',
    getAdminSignUpCodes: '/admin/sign-up-codes',
    getAdminHttpLogs: '/admin/http-logs',
    createAdminInstitute: '/admin/institutes',
    getAdminInstitute: (instituteId: number) => `/admin/institutes/${instituteId}`,
    groupBillingPortal: (groupId: number) => `/groups/${groupId}/billing-portal`,
    createAnnualGroupSubscription: (groupId: number) => `/groups/${groupId}/create-fixed-quantity-subscription`,
    startCheckout: (priceId: string) => `/stripe/prices/${priceId}/checkout`,
    stripeInvoices: (subscriptionId: number) => `/stripe/subscriptions/${subscriptionId}/invoices`,
    createJoinUrl: (groupId: number) => `/groups/${groupId}/join`,
    matchSubscriptionRule: '/subscription-rules/match-email',
    getUsersSearch: '/users/search',
    getGroupPermissions: (groupId: number | string) => `/groups/${groupId}/permissions`,
    updateGroupPermissions: (groupId: number | string) => `/groups/${groupId}/permissions`,
    logInAs() {
        return '/admin/emulate-user';
    },
    getAdminSignUpCode(id: number | string) {
        return `/admin/sign-up-codes/${id}`;
    },
    createAdminSignUpCode: `/admin/sign-up-codes`,
    checkAdminSignUpCode(code: string) {
        return `/sign-up-codes/check?code=${code}`;
    },
    getReferralLink(sourceString: string) {
        return `/me/referral-link?source=${sourceString}`;
    }
}
